import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex'
  },
  variants: {
    color: {
      primary: 'text-black'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
